import { View } from 'foundations-components/components/View';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { CardSection, CardHeader, CardWrapper } from 'foundations-components/transitional/components/Card';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import RecentCompletedPlaylists from './RecentCompletedPlaylists';
import OverviewSectionHeader from './OverviewSectionHeader';
import { ALL_PLAYLISTS_PATH, COMPLETED_PLAYLISTS_PATH, INCOMPLETE_PLAYLISTS_PATH } from '../../constants/routes';
import { trackViewAllClick } from '../../utils/trackingUtils';
import IncompletePlaylists from './IncompletePlaylists';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistsOverview = () => {
  const {
    isLaptop
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(OverviewSectionHeader, {
      button: /*#__PURE__*/_jsx(UIRouterButton, {
        onClick: () => trackViewAllClick('all-playlists'),
        size: "small",
        to: `${ALL_PLAYLISTS_PATH}?sortBy=PLAYLIST_NAME&sortOrder=ASC`,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.overview.playlists.viewAll"
        })
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.playlists.description"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.playlists.title"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(CardGrid, {
        columns: isLaptop ? 1 : 2,
        gutterSize: 20,
        children: [/*#__PURE__*/_jsxs(CardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(CardHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.title"
            }),
            titleSize: "sm",
            toolbar: /*#__PURE__*/_jsx(RouterLink, {
              onClick: () => trackViewAllClick('recent-completed-playlists'),
              to: `${COMPLETED_PLAYLISTS_PATH}?sortBy=COMPLETED_DATE&sortOrder=DESC`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.playlists.recentCompletedPlaylists.viewAll"
              })
            })
          }), /*#__PURE__*/_jsx(CardSection, {
            children: /*#__PURE__*/_jsx(RecentCompletedPlaylists, {})
          })]
        }), /*#__PURE__*/_jsxs(CardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(CardHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.playlists.incompletePlaylists.title"
            }),
            titleSize: "sm",
            toolbar: /*#__PURE__*/_jsx(RouterLink, {
              onClick: () => trackViewAllClick('incomplete-playlists'),
              to: `${INCOMPLETE_PLAYLISTS_PATH}?sortBy=DUE_DATE&sortOrder=DESC&dueDate=PAST`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.playlists.incompletePlaylists.viewAll"
              })
            })
          }), /*#__PURE__*/_jsx(CardSection, {
            children: /*#__PURE__*/_jsx(IncompletePlaylists, {})
          })]
        })]
      })
    })]
  });
};
export default PlaylistsOverview;